const PublicationData = [
  {
    year: "2026",
    venue: "IEEE",
    title:
      "Bridging Spatial and Frequency Views for Disaster Assessment: Benefits and Limitations",
    type: "IEEE IGARSS 2026 Conference Peer Reviewed publication",
    description:
      "Research exploring the integration of spatial and frequency views for disaster assessment in remote sensing and AI workflows.",
    links: {
      github_url: "",
      web_url: "",
    },
  },
  {
    year: "2026",
    venue: "IEEE",
    title:
      "A Unified Framework for Efficient Remote Sensing Visual Question Answering: Adapting Dual, Hybrid, and Encoder-Decoder Architectures",
    type: "IEEE IGARSS 2026 Conference Peer Reviewed publication",
    description:
      "Research on adapting dual, hybrid, and encoder-decoder architectures for efficient visual question answering in remote sensing.",
    links: {
      github_url: "",
      web_url: "",
    },
  },
  {
    year: "2026",
    venue: "IEEE",
    title:
      "Comparison of Deep Learning Frameworks For Rice Disease Mapping From UAV Multispectral Imaging",
    type: "IEEE IGARSS 2026 Conference Peer Reviewed publication",
    description:
      "A comparison of deep learning frameworks for mapping rice disease using UAV multispectral imagery.",
    links: {
      github_url: "",
      web_url: "",
    },
  },
];

export default PublicationData;
